import { FiUser } from 'react-icons/fi'

const AuthLogin = () => {

  return <section className="one hs jc-center ai-center air-4x">
    <form className="login">
      <div className="one vs">
        <FiUser />

        <input
          size={ 1 }
          placeholder="user id"
          className="one"
        />
      </div>

      <div className="one vs jc-end">
        <button>
          request code
        </button>
      </div>
    </form>
  </section>
}

export default AuthLogin
